import { Nursery } from 'services/nurseries/models'
import { STRIPE_STATUSES } from 'services/nurseryIntegrations/constants'

import { generateRoute } from 'utils/routing'
import { createTypeFromEnumValues } from 'utils/typescript'

import {
  APP_MARKETPLACE_STATUS,
  BE_INSPIRED_MARKET_PLACE,
  BE_PAID_MARKET_PLACE,
  BE_SEEN_MARKET_PLACE,
  MarketPlaceProps,
  NOODLE_NOW_MARKET_PLACE,
} from './AppMarketplaceConstants'

interface GetBePaidStatusParams {
  mobilePaymentsIsEnabled: boolean
  status?: string
}

const getBePaidStatus = ({
  mobilePaymentsIsEnabled, status,
}: GetBePaidStatusParams): createTypeFromEnumValues<APP_MARKETPLACE_STATUS> | null => {
  if (!mobilePaymentsIsEnabled) {
    return null
  }

  if (
    status === STRIPE_STATUSES.COMPLETED
    || status === STRIPE_STATUSES.ENABLED
    || status === STRIPE_STATUSES.RESTRICTED_SOON
  ) {
    return 'connected'
  }

  return 'not_connected'
}

interface GetMarketPlaceDataParams {
  isBePaidFetching: boolean
  mobilePaymentsIsEnabled: boolean
  nurseryData: Nursery
}

export const getMarketPlaceData = ({
  isBePaidFetching,
  mobilePaymentsIsEnabled,
  nurseryData,
}: GetMarketPlaceDataParams): MarketPlaceProps[] => ([
  {
    ...BE_PAID_MARKET_PLACE,
    isStatusLoading: isBePaidFetching,
    status: getBePaidStatus({ mobilePaymentsIsEnabled, status: nurseryData?.stripeNurseryIntegration?.status }),
    to: generateRoute('APP_MARKETPLACE.BE_PAID'),
  },
  {
    ...NOODLE_NOW_MARKET_PLACE,
    to: generateRoute('APP_MARKETPLACE.NOODLE_NOW'),
  },
  {
    ...BE_INSPIRED_MARKET_PLACE,
    to: generateRoute('APP_MARKETPLACE.BE_INSPIRED'),
  },
  {
    ...BE_SEEN_MARKET_PLACE,
    to: generateRoute('APP_MARKETPLACE.BE_SEEN'),
  },
])
